import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const ShareIconVideo: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      width={width ?? '64'}
      height={height ?? '64'}
      viewBox='0 0 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M21.9993 50.3307C21.0827 50.3307 20.298 50.0043 19.6452 49.3516C18.9924 48.6988 18.666 47.9141 18.666 46.9974V28.6641C18.666 27.7474 18.9924 26.9627 19.6452 26.3099C20.298 25.6571 21.0827 25.3307 21.9993 25.3307H26.9993V28.6641H21.9993V46.9974H41.9993V28.6641H36.9993V25.3307H41.9993C42.916 25.3307 43.7007 25.6571 44.3535 26.3099C45.0063 26.9627 45.3327 27.7474 45.3327 28.6641V46.9974C45.3327 47.9141 45.0063 48.6988 44.3535 49.3516C43.7007 50.0043 42.916 50.3307 41.9993 50.3307H21.9993ZM30.3327 38.6641V20.0391L27.666 22.7057L25.3327 20.3307L31.9993 13.6641L38.666 20.3307L36.3327 22.7057L33.666 20.0391V38.6641H30.3327Z'
        fill={fill ?? 'white'}
      />
    </svg>
  );
};

export default ShareIconVideo;
